import React, { FC, useEffect } from "react";
import { Typography, styled } from "@mui/material";
import Schedule from "assets/image/schedule.webp";
import { isDarkMode } from "utills";
import { Maybe } from "api";



const MissedStrick: FC<{ data: Maybe<string> | undefined }> = ({ data }) => {

  const popupData = JSON.parse(data as string);
  console.log(popupData);

  return (
    <>
      <Container>
        <Image src={Schedule} />
        <Subtitle1>
          {popupData?.title}
        </Subtitle1>
        <Body1>
          {popupData?.text1}
        </Body1>
        <ButtomContainer>
          <Caption>
            {popupData?.text2}
          </Caption>
        </ButtomContainer>
      </Container>
    </>
  );
};

export default MissedStrick;

const Container = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 10,
  zIndex: 9,
  paddingTop: 50,
  position: 'relative',
  overflowX: 'hidden',
  "&::after": {
    content: '""',
    backgroundImage: isDarkMode(theme) ? 'linear-gradient(#16181c, #e4f1ff)' : 'linear-gradient(#f6fffa, #e4f1ff)',
    position: 'absolute',
    top: 0,
    left: '-10%',
    right: '-10%',
    height: '30%',
    borderBottomLeftRadius: '50%',
    borderBottomRightRadius: '50%',
    zIndex: -1
  }

}))

const Subtitle1 = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '30px',
  marginBottom: 10,
  marginTop: 25,
  color: isDarkMode(theme) ? "#fff" : '#131722',
  textAlign: "center"
}))

const Body1 = styled(Typography)({
  fontSize: 16,
  marginBottom: 20,
  color: '#606060',
  textAlign: "center"
})

const ButtomContainer = styled('div')({
  padding: '12px 0px',
  margin: 'auto',
  borderRadius: 40,
  marginTop: 5,
  marginBottom: 15

})

const Caption = styled('p')(({ theme }) => ({
  color: isDarkMode(theme) ? "#fff" : '#000',
  fontWeight: 700,
  fontSize: 16,
  textAlign: 'center'
}))


const Image = styled(
  (
    props: React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >
  ) => <img height={80} width={80} {...props} />
)(({ theme }) => ({
  height: 100,
  width: 100,
  marginTop: -20,
}));
